import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { type IProductDataV3 } from '@df/catalog/product/product';
import { HTMLBindingDirective } from '@df/ui/common/html-binding.directive';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ProductDecorator } from '../../../../../model/product/product.decorator';

export enum EBackorderDeliveryTimeOption {
    availableNow = 3254
}

@Component({
    selector: 'product-layout-delivery-messages',
    templateUrl: './product-layout-delivery-messages.component.html',
    imports: [HTMLBindingDirective, OptionLabelPipe, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLayoutDeliveryMessagesComponent extends UiComponent {
    readonly product = input.required<ProductDecorator<IProductDataV3>>();

    readonly backorderDeliveryTime = computed(() => this.product().backorderDeliveryTime);
    readonly deliveryFlag = computed(() => this.product().deliveryFlag);

    readonly canShowBackorderDeliveryTime = computed(
        () => !!this.backorderDeliveryTime() && this.backorderDeliveryTime() !== EBackorderDeliveryTimeOption.availableNow
    );
}
